import React from 'react';

export default class TwitchIcon extends React.Component {
    constructor(props) {
        super(props);
        this.loadSvg();
        this.setIconElement();
    }

    loadSvg() {
        const loadSvg = () => {
            const iconTemplate = document.querySelector("#TwitchLogo");
            this.iconSvg = iconTemplate.innerHTML;
        };
        if (document.readyState !== 'loading') {
            loadSvg();
        } else {
            document.addEventListener('DOMContentLoaded', loadSvg);
        }
    }

    setIconElement() {
        const styles = this.props?.style || {};
        const width = this.props?.width || 12;
        const height = this.props?.height || 12;
        if (!styles?.width) {
            styles.width = `${width}px`;
        }
        if (!styles?.height) {
            styles.height = `${height}px`;
        }
        this.iconElement = (
            <svg id="TwitchLogo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} style={styles} dangerouslySetInnerHTML={{ __html: this.iconSvg }}></svg>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props?.style === prevProps?.style && this.props?.width === prevProps?.width && this.props?.height === prevProps?.height) {
            return;
        }
        this.setIconElement();
    }

    render() {
        return this.iconElement;
    }
}
